// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { handleAPIError } from '@/api/error-utils';
import { AxiosError } from 'axios';

/**
 * Backend status code returned when application-level validation finds a
 * bundle with the same name (ErrorCodeBundleNameExists).
 */
const BUNDLE_NAME_EXISTS_STATUS_CODE = 4001;

/**
 * Backend status code returned when the bundle_u_org_name unique constraint
 * is violated (ErrorCodeViolationBundleDuplicateName).
 */
const BUNDLE_DUPLICATE_NAME_VIOLATION_STATUS_CODE = 5024;

/**
 * Checks whether an API error indicates a duplicate bundle name.
 * Both backend codes are exclusively "a bundle with this name already
 * exists" errors, so matching on the status code is sufficient.
 */
export function isDuplicateBundleNameError(error: AxiosError): boolean {
  const apiError = handleAPIError(error);
  return (
    apiError.apiStatusCode === BUNDLE_NAME_EXISTS_STATUS_CODE ||
    apiError.apiStatusCode === BUNDLE_DUPLICATE_NAME_VIOLATION_STATUS_CODE
  );
}
